import ColorBlock from 'components/ColorBlock';
import React from 'react';
export default {
  ColorBlock,
  React
};